import type { ConversationView } from '../../api/chat.types';
import { Avatar } from '../social/Avatar';
import { chatListTime } from '../social/format';

function lastMessagePreview(c: ConversationView, meId: string | undefined) {
  const last = c.lastMessage;
  if (!last) return 'Chưa có tin nhắn';
  const text = last.text || (last.hasImage ? 'Đã gửi một ảnh' : 'Đã chia sẻ một thẻ từ vựng');
  if (last.senderId === meId) return `Bạn: ${text}`;
  return c.kind === 'GROUP' ? `${last.senderName.trim().split(' ').slice(-2).join(' ')}: ${text}` : text;
}

/** Hàng hội thoại — ChatRow của bản thiết kế. `active` = đang mở ở khung bên phải. */
export function ConversationRow({ conversation: c, meId, active, onOpen }: { conversation: ConversationView; meId: string | undefined; active: boolean; onOpen: () => void }) {
  const unread = c.unread > 0;
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-current={active ? 'true' : undefined}
      aria-label={unread ? `${c.name}, ${c.unread} tin chưa đọc` : c.name}
      className={`sk-press${active ? ' sk-on' : ''}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        width: '100%',
        padding: '10px 8px',
        minHeight: 72,
        border: 'none',
        borderRadius: 'var(--radius-control)',
        cursor: 'pointer',
        textAlign: 'left',
        fontFamily: 'var(--font-vi)',
      }}
    >
      <Avatar name={c.name} size={50} mark={c.mark} online={c.kind === 'DM' && !!c.peer?.online} tone={c.kind === 'GROUP' ? 0 : undefined} />
      <span style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 3 }}>
        <span style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
          <span style={{ flex: 1, minWidth: 0, fontSize: 15, fontWeight: 700, color: 'var(--ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.name}</span>
          {c.lastMessageAt && (
            <span style={{ fontSize: 12, fontWeight: unread ? 700 : 500, color: unread ? 'var(--navy-500)' : 'var(--text-secondary)', flexShrink: 0 }}>{chatListTime(c.lastMessageAt)}</span>
          )}
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span
            style={{
              flex: 1,
              minWidth: 0,
              fontSize: 13,
              fontWeight: unread ? 600 : 400,
              color: unread ? 'var(--ink)' : 'var(--text-secondary)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {lastMessagePreview(c, meId)}
          </span>
          {unread && (
            <span
              style={{
                minWidth: 20,
                height: 20,
                padding: '0 6px',
                borderRadius: 999,
                background: 'var(--navy-500)',
                color: '#fff',
                fontSize: 12,
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {c.unread > 99 ? '99+' : c.unread}
            </span>
          )}
        </span>
      </span>
    </button>
  );
}
